import { render, staticRenderFns } from "./BuyTable.vue?vue&type=template&id=f711e23e&scoped=true&"
import script from "./BuyTable.vue?vue&type=script&lang=js&"
export * from "./BuyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f711e23e",
  null
  
)

export default component.exports